export default __webpack_public_path__ + "static/software.stack.balance-6217f906e07d9c87cbb4431fdd35f8c3.webp";